import type { Provider } from '@app/src/types/organizations'
import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, Divider, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import type { ProviderListProps } from './ProviderList'
import ProviderList from './ProviderList'

type AccordionSectionProps = {
  isExpanded: boolean
  onToggle: () => void
  icon: React.ReactNode
  summaryText: string
  providers: Provider[]
  templateId: number | null
  assessmentTemplate?: AssessmentTemplate
  selectable?: ProviderListProps['selectable']
  showLevel?: boolean
  isFirst?: boolean
  isLast?: boolean
}

const AccordionSection: React.FC<AccordionSectionProps> = ({
  isExpanded,
  onToggle,
  icon,
  summaryText,
  providers,
  templateId,
  assessmentTemplate,
  selectable,
  showLevel = true,
  isFirst = true,
  isLast = true,
}) => {
  const { formatMessage } = useIntl()

  return (
    <>
      {!isFirst && <Divider />}
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          bgcolor: 'grey.100',
          borderTopLeftRadius: isFirst ? 4 : 0,
          borderTopRightRadius: isFirst ? 4 : 0,
          borderBottomLeftRadius: isLast ? 4 : 0,
          borderBottomRightRadius: isLast ? 4 : 0,
          px: 2,
          py: 1.5,
        }}
      >
        {icon}
        <Typography variant="body1" sx={{ flexGrow: 1 }}>
          {summaryText}
        </Typography>
        <IconButton
          onClick={onToggle}
          disabled={providers.length === 0}
          size="small"
          aria-expanded={isExpanded}
          aria-label={formatMessage({ id: 'bulkCreateExpectation.steps.selectedCompanies.toggleListAriaLabel' })}
        >
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Stack>

      <Collapse in={isExpanded && providers.length > 0}>
        <ProviderList
          providers={providers}
          templateId={templateId}
          assessmentTemplate={assessmentTemplate}
          selectable={selectable}
          showLevel={showLevel}
        />
      </Collapse>
    </>
  )
}

export default AccordionSection
